import React from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";


const PublicOfferSuccessPage = () => {

  const {
    token,
  } = useParams();


  const navigate =
    useNavigate();


  return (

    <main className="public-offer-success-page">

      <div className="public-offer-success-card">

        <div className="public-offer-success-icon">
          ✓
        </div>


        <h1>
          Thank You
        </h1>


        <p>
          Your offer has been accepted
          successfully.
        </p>


        <p className="public-offer-success-secondary">

          Your payment confirmation and
          transaction details will be
          available after the payment
          is completed.

        </p>


        <button
          type="button"
          className="public-offer-primary-button"

          onClick={() =>
            navigate(
              `/offer/${token}`
            )
          }

        >
          View Offer
        </button>

      </div>

    </main>

  );

};


export default PublicOfferSuccessPage;